import styled from 'styled-components';

export const StageVideoWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .stage-layout-toggle-wrap {
    position: static;
    flex-shrink: 0;
    align-self: flex-start;
    margin-left: 6px;
    margin-top: -2px;
    z-index: 30;
  }
`;
